/**
 * Local calendar date only (e.g. 20 Apr 2026).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatHubMedDateOnly(value) {
  if (value == null || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(d);
}

/**
 * Human-readable local datetime for onboarding comments (e.g. 20 Apr 2026, 10:30 pm).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatHubMedNoteDateTime(value) {
  if (value == null || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
}

/**
 * Date/time in Australia/Sydney (for HubMed daily log create timestamps).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatHubMedDateTimeSydney(value) {
  if (value == null || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-AU", {
    timeZone: "Australia/Sydney",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(d);
}

/**
 * Time only in Australia/Sydney (date comes from the log date selector).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatHubMedTimeSydney(value) {
  if (value == null || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-AU", {
    timeZone: "Australia/Sydney",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(d);
}
